module.exports = __webpack_public_path__ + "./docs/img/icon-minus.3f8609def3d84fdde4ae7db5166b7ae3.svg";